class MainReview extends HTMLElement {
  constructor() {
    super();
  }   

  connectedCallback(){
    this.initSliderButton();
    this.initSliderReview();
    this.initCategoryFilter();
    this.initAddToCart();
    this.initReviewTruncation();
    this.refreshReviewTruncation();
  }

  initSliderButton(){
    const el = this.querySelector('.swiper-button');
    if (!el) return;
    this.swiperButton = new Swiper(el, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 10,
    });
  }
  
  initSliderReview(){
    const content = this.querySelector('.swiper-content');
    if (!content) return;
    const paginationEl = this.querySelector('.swiper-pagination');
    const nextEl = this.querySelector('.swiper-button-next');
    const prevEl = this.querySelector('.swiper-button-prev');

    const options = {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      allowTouchMove: false,
      spaceBetween: 10,
    };
    if (paginationEl) options.pagination = { el: paginationEl };
    if (nextEl && prevEl) options.navigation = { nextEl, prevEl };

    this.swiperReview = new Swiper(content, options);
    this.swiperReview.on('slideChange', () => this.refreshReviewTruncation());
    this.swiperReview.on('transitionEnd', () => this.refreshReviewTruncation());
  }

  initCategoryFilter() {
    const buttons = this.querySelectorAll('.button-category');
    const slides = this.querySelectorAll('.swiper-content .swiper-slide[data-category]');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const selectedCategory = button.getAttribute('data-category');

        buttons.forEach(btn => btn.classList.remove('actived'));
        button.classList.add('actived');

        slides.forEach(slide => {
          if (slide.getAttribute('data-category') === selectedCategory) {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        });

        this.swiperReview?.update();
        this.refreshReviewTruncation();
      });
    });
  }

  refreshReviewTruncation() {
    if (!this.reviewTruncationChecks?.length) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.reviewTruncationChecks.forEach(check => check());
      });
    });
  }

  initReviewTruncation() {
    this.reviewTruncationChecks = [];

    this.querySelectorAll('.content-review__title-content--crop').forEach(crop => {
      const full = crop.nextElementSibling;
      if (!full || !full.classList.contains('content-review__title-content--full')) return;
      const toggle = full.nextElementSibling;
      if (!toggle || !toggle.classList.contains('content-review__toggle')) return;

      const p = crop.querySelector('p');
      if (!p) return;
      const fullP = full.querySelector('p');

      const check = () => {
        if (window.innerWidth > 989) {
          crop.classList.remove('hidden');
          full.classList.add('hidden');
          toggle.classList.add('hidden');
          return;
        }
        const prev = p.style.webkitLineClamp;
        p.style.webkitLineClamp = 'unset';
        const natural = p.scrollHeight;
        p.style.webkitLineClamp = prev;
        const clamped = p.clientHeight;
        let isOverflow = natural > clamped + 1;

        // Fallback for browsers/layout states where line-clamp metrics are unreliable.
        if (!isOverflow && fullP?.textContent) {
          isOverflow = fullP.textContent.trim().length > 180;
        }

        toggle.classList.toggle('hidden', !isOverflow);
      };

      this.reviewTruncationChecks.push(check);
      requestAnimationFrame(() => requestAnimationFrame(check));
      window.addEventListener('resize', check);

      toggle.addEventListener('click', () => {
        const showing = crop.classList.contains('hidden');
        if (showing) {
          crop.classList.remove('hidden');
          full.classList.add('hidden');
          toggle.textContent = 'Voir plus';
        } else {
          crop.classList.add('hidden');
          full.classList.remove('hidden');
          toggle.textContent = 'Voir moins';
        }
      });
    });
  }

  initAddToCart() {
    this.querySelectorAll('.buy-button, .buy-button-card').forEach(btn => {
      btn.addEventListener('click', () => {
        const variantId = parseInt(btn.dataset.variant);
        if (!variantId) return;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then(res => res.json())
          .then(() => {
            window.location.href = '/cart';
          });
      });
    });
  }
}

customElements.define('main-review', MainReview);
